import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ModalService} from "../../services/modal.service";
import {APP_MESSAGES} from "../../enums/enums";
import {PreloaderService} from "../../services/preloader.service";
import {Http, Response, Headers} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {ErrorService} from "../../services/error.service";
import {delay, first, repeat, switchMapTo, takeUntil, timeout} from "rxjs/operators";
import {Subject} from "rxjs/Subject";
import {of} from "rxjs/observable/of";
import {timer} from "rxjs/observable/timer";
import {HistoryService} from "../../services/history.service";

declare const $:any;
//import * as bootstrap from "bootstrap";

@Component({
  selector: 'app-nv-meta-import-modal',
  templateUrl: './nv-meta-import-modal.component.html',
  styles: []
})
export class NvMetaImportModalComponent implements OnInit {

  @ViewChild("modalRoot") element: ElementRef
  metaInName:string
  queryString:string;
  ASSETS_POLL_PERIOD = 5000;
  importAssetsStatus = "";

  constructor(private http:Http,
              private modalService:ModalService,
              private preloaderService:PreloaderService,
              private errorService:ErrorService,
              private  historyService:HistoryService) { }

  ngOnInit() {
    this.modalService.onModalRequest
      .filter(appMessage => appMessage.type === APP_MESSAGES.POPUP_META_IMPORT)
      .subscribe(appMessage => this.show(appMessage.content));
  }

  onImportAllClick() {
    this.preloaderService.show();
    this.sendData("/meta/import-all-meta", {name:this.metaInName})
      .subscribe((json:any) => {
        //console.log(json);
          this.historyService.addCheckpoint(`Импорт меты из ${this.metaInName}`).subscribe();
          this.preloaderService.hide();
      });
  }

  onImportAssetsClick() {
    this.historyService.addCheckpoint(`Попытка импорта ассетов из ${this.metaInName}`).subscribe(() => {
      this.preloaderService.show();
      this.sendData("/animations/import-all-assets", {name:this.metaInName}).subscribe((json) => {
        console.log(json.message);
        if (json.message == "start") {
          let pollResult = new Subject<void>();
          this.sendGet("animations/import-all-assets-poll").pipe(
            repeat(),
            takeUntil(pollResult)
          ).subscribe((resp:Response) => {
            let json = resp.json();
            console.log(json);
            if (json.message == "ok") {
              console.log("ok");
              pollResult.next();
              pollResult.complete();
              this.importAssetsStatus = "Успешный импорт ассетов";
              this.historyService.addCheckpoint(`Успешный импорт ассетов из ${this.metaInName}`).subscribe();
            }
            else if (json.message == "error") {
              this.importAssetsStatus = "Ошибка импорта ассетов! (Ничего страшного, попробуй еще раз)";
              this.historyService.addCheckpoint(`Ошибка импорта ассетов: ${json.error}`).subscribe();
            }
          });
        }
        else if (json.message == "progress") {
          this.importAssetsStatus = "Импорт ассетов уже в процессе!";
          this.historyService.addCheckpoint("Импорт ассетов уже в процессе!").subscribe();
        }
      });
    });
  }

  onImportQueryClick() {
    if (this.queryString != null && this.queryString != "") {
      this.preloaderService.show();
      var query = JSON.parse(this.queryString);
      console.log(query);
      this.sendData("/meta/import-meta-objects", {name:this.metaInName, query:query}).subscribe(() => {
        this.historyService.addCheckpoint(`Импорт объектов  ${JSON.stringify(query)} из ${this.metaInName}`).subscribe(() => {
          this.historyService.addCheckpoint(`Попытка импорта ассетов из ${this.metaInName} для ${JSON.stringify(query)}`).subscribe(() => {
            this.preloaderService.show();
            this.sendData("animations/import-assets-objects", {name:this.metaInName, query:query}).subscribe((json) => {
              console.log(json.message);
              if (json.message == "start") {
                let pollResult = new Subject<void>();
                this.sendGet("animations/import-assets-objects-poll").pipe(
                  repeat(),
                  takeUntil(pollResult)
                ).subscribe((resp:Response) => {
                  let json = resp.json();
                  console.log(json);
                  if (json.message == "ok") {
                    console.log("ok");
                    pollResult.next();
                    pollResult.complete();
                    this.importAssetsStatus = "Успешный импорт ассетов";
                    this.historyService.addCheckpoint(`Успешный импорт ассетов из ${this.metaInName} для ${JSON.stringify(query)}`).subscribe();
                  }
                  else if (json.message == "error") {
                    this.importAssetsStatus = "Ошибка импорта ассетов! (Ничего страшного, попробуй еще раз)";
                    this.historyService.addCheckpoint(`Ошибка импорта ассетов: ${json.error}`).subscribe();
                  }
                });
              }
              else if (json.message == "progress") {
                this.importAssetsStatus = "Импорт ассетов уже в процессе!";
                this.historyService.addCheckpoint("Импорт ассетов уже в процессе!").subscribe();
              }
            });
          });
        });
      });
    }
  }

  private sendData(uri:string, data:any = null):Observable<any> {
    return this.http.post(uri, data)
      .map((r:Response) => {
        let j = null;
        try {
          j = r.arrayBuffer().byteLength > 0 ? r.json() : {};
        } catch (e) {
          j = {};
        }
        return j;
      })
      .catch(e => this.errorService.handleError(e));
  }

  private sendGet(url:string): Observable<Response> {
    return this.http.get(url)
      .map((r: Response): Response => {
        return r;
      })
      .catch((e: any): any => this.errorService.handleError(e));
  }

  private show(metaInName:string){
    //console.log(this.journal);
    this.metaInName = metaInName;
    $(this.element.nativeElement).modal();
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-meta-import-modal/nv-meta-import-modal.component.ts